import React, { useState, useContext} from 'react';
import logo from "./logo.png";
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import { CircularProgress } from '@mui/material';
import { DataContext } from './DataContext';
import { useNavigate } from 'react-router-dom';

const HomePage = () => {
    const [transcriptFile, setTranscriptFile] = useState(null);
    const [attendancefile, setAttendanceFile] = useState(null);
    const [isSubmit, setisSubmit] = useState(false)
    const { fetchData } = useContext(DataContext);
    const navigate = useNavigate();

    
    const getFileExtension = (file)=>{
        return file.name.split('.').pop().toLowerCase()
    }



    
    const handleSubmit = () => {
        if (!transcriptFile || !attendancefile) {
            alert('Please upload both files');
            return;
        }

        console.log('Submitting Transcript File:', transcriptFile); // Debugging log
        console.log('Submitting Attendance File:', attendancefile); // Debugging log

        setisSubmit(true);
        fetchData(transcriptFile, attendancefile); // Pass files to fetchData
        setTimeout(() => {
            setisSubmit(false);
            navigate('/data-display');
        }, 5000);
    }
    const handleMeetingTranscript=(event)=>{
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            const fileExtension = getFileExtension(selectedFile);
            if (fileExtension === 'docx' || fileExtension === 'txt') {
                // setFile(selectedFile);
                setTranscriptFile(selectedFile);
                console.log(transcriptFile)
            } else {
                alert('Please select a .txt or .docx file.');
                event.target.value = ''; // Clear the input
            }
        }
    }

    const handleMeetingAttendance=(event)=>{
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            const fileExtension = getFileExtension(selectedFile);
            if (fileExtension === 'csv') {
                // setFile(selectedFile);
                setAttendanceFile(selectedFile)
                console.log(attendancefile)
            } else {
                alert('Please select a .csv file.');
                event.target.value = ''; // Clear the input
            }
        }
    }
  return (
    <div className='container'>
            <div className='logo'>
                <img
                    src={logo}
                    alt='Logo'
                    className='img-fluid'
                    style={{ "maxWidth": "50px" }}
                />
                <h2>MeetScribe</h2>
            </div>
            <div className='row'>
                <div className='col-md-6'>
                        <div className='form-group files'>
                            <label htmlFor='fileUploaderdoc' aria-hidden='true'>
                                Upload Meeting Transcript (.docx, .txt)
                                <Tooltip title={
                                    <span>
                                        <strong>Step1-</strong> Ensure to “Start recording” the meeting<br/>
                                        <strong>Step2-</strong> Once the meeting is over, the message “Recording is ready” will appear in the meeting chat window<br/>
                                        <strong>Step3-</strong> “Transcript” will be available in the meeting chat window<br/>
                                        <strong>Step4-</strong> Click on “Transcript” and then “Download”<br/>
                                        <strong style={{'color': '#f47e16'}}>Please Note:</strong> Only the owner of the invite will be able to download
                                    </span>}>
                                    <IconButton>
                                        <InfoIcon />
                                    </IconButton>
                                </Tooltip>
                            </label>
                            <input
                                id='fileUploaderdoc'
                                type='file'
                                className='form-control'
                                multiple=''
                                accept='.txt,.docx'
                                onChange={handleMeetingTranscript}
                            />
                        </div>
                </div>
                <div className='col-md-6'>
                        <div className='form-group files color'>
                            <label htmlFor='fileUploadercsv' aria-hidden='true'>
                                Upload Meeting Attendance (.csv)
                                <Tooltip title={
                                    <span>
                                        <strong>Step1-</strong> Ensure to “Start recording” the meeting<br/>
                                        <strong>Step2-</strong> Once the meeting is over, the message “Recording is ready” will appear in the meeting chat window<br/>
                                        <strong>Step3-</strong> “Attendance” will be available in the meeting chat window<br/>
                                        <strong>Step4-</strong> Click on “Attendance” and then “Download”<br/>
                                        <strong style={{'color': '#f47e16'}}>Please Note:</strong> Only the owner of the invite will be able to download
                                    </span>}>
                                    <IconButton>
                                        <InfoIcon />
                                    </IconButton>
                                </Tooltip>
                            </label>
                            <input
                                id='fileUploadercsv'
                                type='file'
                                className='form-control'
                                multiple=''
                                accept='.csv'
                                onChange={handleMeetingAttendance}
                            />
                        </div>
                </div>
            </div>
            <div>
            </div>
            <div className='save-button'>
                <Button loading={isSubmit} loadingIndicator={<><CircularProgress size={20}/> Please wait...</>} variant="contained" sx={{ width: '18.6em' }} onClick={handleSubmit}>Submit</Button>
            </div>
        </div>
  );
};

export default HomePage;